/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Least_Mild_Parrot_LeadInputs */

const fr_least_mild_parrot_lead = /** @type {(inputs: Least_Mild_Parrot_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialise ton mot de passe`)
};

/**

* @param {Least_Mild_Parrot_LeadInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const least_mild_parrot_lead = /** @type {((inputs?: Least_Mild_Parrot_LeadInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Least_Mild_Parrot_LeadInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_least_mild_parrot_lead(inputs)
});